import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@core/services/translation.service';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base.component';
import { GrpserviceService } from '../../grpservice.service';

@Component({
  selector: 'app-add-edit-category-dialog',
  templateUrl: './add-edit-category-dialog.component.html',
  styleUrls: ['./add-edit-category-dialog.component.scss'],
})
export class AddEditCategoryDialogComponent
  extends BaseComponent
  implements OnInit
{
  categoryForm!: FormGroup;
  isEdit = false;
  isSubCategory = false;

  constructor(
    public dialogRef: MatDialogRef<AddEditCategoryDialogComponent>,
    private fb: FormBuilder,
    private categoryService: GrpserviceService,
    private toastrService: ToastrService,
    public translationService: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(translationService);
  }

  ngOnInit(): void {
    this.isEdit = !!this.data?.id;
    this.isSubCategory = !!this.data?.categoryId; // if categoryId exists, it's a subcategory

    // Setup form fields based on type
    this.categoryForm = this.fb.group({
      id: [this.data?.id || 0],
      name: [
        this.isSubCategory
          ? this.data?.subCategoryName || this.data?.name || ''
          : this.data?.categoryName || '',
        Validators.required,
      ],
      nIndex: [this.data?.nIndex || 0],
      isActive: [this.data?.isActive ?? this.data?.isEnabled ?? 1],
    });

    // If edit mode and subcategory, fetch latest data by id
    if (this.isEdit && this.isSubCategory && this.data.id) {
      this.categoryService.getSubCategoryDataById(this.data.id).subscribe(
        (res: any) => {
          const sub = res.data || res;
          this.categoryForm.patchValue({
            name: sub.subCategoryName || sub.name,
            nIndex: sub.nIndex,
            isActive: sub.isActive,
          });
        },
        (err) => console.error('Error loading subcategory by ID:', err)
      );
    }
  }

  onSubmit(): void {
    if (this.categoryForm.invalid) return;

    const formData = this.categoryForm.value;
    const authObj = JSON.parse(localStorage.getItem('authObj') || '{}');
    const fullName =
      authObj.firstName && authObj.lastName
        ? `${authObj.firstName} ${authObj.lastName}`
        : authObj.userName || '';

    let request$;

    if (this.isSubCategory) {
      // ---- SUBCATEGORY ----
      if (this.isEdit) {
        const payload = {
          id: formData.id,
          subCategoryName: formData.name,
          // categoryId: this.data.categoryId,
          userId: authObj.id,
          updatedBy: fullName,
          isActive: formData.isActive ? 1 : 0,
          nIndex: formData.nIndex || 0,
        };
        request$ = this.categoryService.updateSubCategory(payload);
      } else {
        const payload = {
          subCategoryName: formData.name,
          categoryId: this.data.categoryId,
          userId: authObj.id,
          createdBy: fullName,
          isActive: formData.isActive ? 1 : 0,
          nIndex: formData.nIndex || 0,
        };
        request$ = this.categoryService.createSubCategory(payload);
      }
    } else {
      // ---- CATEGORY ----
      if (this.isEdit) {
        const payload = {
          id: formData.id,
          categoryName: formData.name,
          updatedByName: fullName,
          userId: authObj.id,
          nIndex: formData.nIndex || 0,
          isActive: formData.isActive ? 1 : 0,
          module: '',
        };
        request$ = this.categoryService.updateSubject(payload);
      } else {
        const payload = {
          categoryName: formData.name,
          createdByName: fullName,
          userId: authObj.id,
          isActive: formData.isActive ? 1 : 0,
          nIndex: formData.nIndex || 0,
          module: '',
        };
        request$ = this.categoryService.createSubject(payload);
      }
    }

    request$.subscribe(
      () => {
        this.toastrService.success(
          `${this.isSubCategory ? 'Sub Category' : 'Category'} ${
            this.isEdit ? 'Updated' : 'Created'
          } successfully`
        );
        this.dialogRef.close(true);
      },
      (err) => {
        console.error('Error saving record:', err);
        this.toastrService.error('Operation failed. Please try again.');
      }
    );
  }

  get f() {
    return this.categoryForm.controls;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  checkChange(event: any) {
    this.categoryForm.patchValue({ isActive: event.checked ? 1 : 0 });
  }
}
